import { Component } from "react"

/* Link */
import { NavLink } from "react-router-dom"

/* Redux */
import { connect } from "react-redux"

/* Constants */
import { menu } from "../constants"

/* Timezone Switcher */
import TimezoneSwitcher from "./TimezoneSwitcher"

/* Icons */
import { DotsIcon } from "./Icons"

/* Translate */
import { t } from "../translates/translate"

/* PitBoard — a row that opens another service instead of a page */
import { openPitBoard } from "./PitBoard"


/* THE NUMBER OF ROWS THE BAR KEEPS — THE REST WAITS INSIDE THE SHEET */
const TABS = 4


/* Component Mobile Tab */
class MobileTab extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
        }
    }


    componentDidMount = () => {
        document.addEventListener("click", this.handleClickOutside, true)
    }

    componentWillUnmount = () => {
        document.removeEventListener("click", this.handleClickOutside, true)
    }


    /* Click Outside Handler */
    handleClickOutside = (event) => {
        if (this.state.visible && this._box && !this._box.contains(event.target)) {
            this.setState({ visible: false })
        }
    }


    /* Run The Action Of A Row — PitBoard opens in a tab of its own */
    action = (item) => {

        this.setState({ visible: false })

        if (item.action === "pitboard") {
            openPitBoard()
        }
    }


    /* Draw The Bar — THE FIRST ROWS OF THE MENU AND THE HANDLE OF THE SHEET */
    _tabs = (tabs) => {

        const { visible } = this.state

        return (
            <div className="mobile-menu">

                {tabs.map((item, index) => item.action
                    ? <div onClick={() => this.action(item)} key={`${index}`} className="mobile-menu-item">
                        <div className="mobile-menu-image">{item.image}</div>
                        <span className="mobile-menu-label">{item.text}</span>
                    </div>
                    : <NavLink onClick={() => this.setState({ visible: false })} key={`${index}`} to={item.link} className="mobile-menu-item">
                        <div className="mobile-menu-image">{item.image}</div>
                        <span className="mobile-menu-label">{item.text}</span>
                    </NavLink>
                )}

                <div onClick={() => this.setState({ visible: !visible })} className={`mobile-menu-item ${visible ? "active" : ""}`}>
                    <div className="mobile-menu-image"><DotsIcon size={19} /></div>
                    <span className="mobile-menu-label">{t("menu.more")}</span>
                </div>

            </div>
        )
    }


    /* Draw The Sheet — EVERY ROW THE BAR HAD NO PLACE FOR */
    _sheet = (rest) => {

        const { visible } = this.state

        return (
            <div className={`mobile-menu-bar ${visible ? "active" : ""}`}>

                {rest.map((item, index) => {

                    /* Draw Divider */
                    if (item.name === "space") {
                        return <div className="mobile-menu-bar-space" key={`${index}`} />
                    }

                    /* Draw Action */
                    if (item.action) {
                        return (
                            <div onClick={() => this.action(item)} key={`${index}`} className="mobile-menu-bar-item">
                                <div className="mobile-menu-bar-image">{item.image}</div>
                                <span>{item.text}</span>
                            </div>
                        )
                    }

                    return (
                        <NavLink onClick={() => this.setState({ visible: false })} key={`${index}`} to={item.link} className="mobile-menu-bar-item">
                            <div className="mobile-menu-bar-image">{item.image}</div>
                            <span>{item.text}</span>
                        </NavLink>
                    )
                })}

                {/* Timezone (UTC) & Language Switcher */}
                <div className="mobile-menu-bar-tz" onClick={() => this.setState({ visible: false })}>
                    <TimezoneSwitcher />
                </div>

            </div>
        )
    }


    render = () => {

        const { admin } = this.props

        /* Fields */
        const items = menu.getItems(admin)
        const tabs = items.filter((item) => item.name !== "space").slice(0, TABS)
        const rest = menu.clean(items.filter((item) => !tabs.includes(item)))

        return (
            <div ref={(ref) => this._box = ref} className="mobile-menu-container">

                {/* Draw The Bar */}
                {this._tabs(tabs)}

                {/* Draw The Sheet */}
                {this._sheet(rest)}

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        language: state.language,
    }
}

export default connect(mapStateToProps)(MobileTab)
